// extracted by mini-css-extract-plugin
export default {"filingAttributesGroup":"developmentFilingAttributes_filingAttributesGroup__IWqNq","separator":"developmentFilingAttributes_separator__0Jgmb"};